import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoMedia from 'theme/promoMedia';

import HeadingSection from './HeadingSection';
import { ListingTile } from '../ListingTile/ListingTile';

const Container = styled.div`
    display: flex;
    margin: 0 -6px 32px -6px;
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 20px;

    ${promoMedia.tablet744} {
        margin: 0 -12px 48px -12px;
        row-gap: 24px;
    }

    ${promoMedia.desktop1440} {
        margin: 0 -16px 64px -16px;
        row-gap: 32px;
    }
`;
const TileContainer = styled.div`
    width: 50%;

    ${promoMedia.desktop1440} {
        width: 25%;
    }
`;

const LocationSection = (props) => {
    return (
        <>
            {props.sectionTitle && <HeadingSection title={props.sectionTitle} text={props.sectionText} />}
            <Container>
                {Array.isArray(props.data) &&
                    props.data
                        .filter((item) => item !== null)
                        .map((item) => {
                            return (
                                <TileContainer key={item.id}>
                                    <ListingTile img={item.img} title={item.title} loadingLazy={props.loadingLazy} />
                                </TileContainer>
                            );
                        })}
            </Container>
        </>
    );
};

LocationSection.propTypes = {
    sectionTitle: PropTypes.string,
    sectionText: PropTypes.string,
    data: PropTypes.array,
    loadingLazy: PropTypes.bool,
};

export default LocationSection;
